import { isFakeFreeConsumerTestFlightOn } from 'owa-proofing-option/lib/utils/isFakeFreeConsumerTestFlightOn';
import { lazyGetDefaultOptions } from 'owa-proofing-option';

const mockNonPremiumUserMockOptions = [
    {
        id: '818bcdbe-64ce-46e8-a3d7-75a1ea8365a8',
        name: 'Frequently confused words',
        defaultCritiqueValue: 1,
    },
    {
        id: '5cb7fc16-cd78-449c-86d9-5d047be21ac4',
        name: 'Adjective Used instead of Adverb',
        defaultCritiqueValue: 1,
    },
    {
        id: 'f57c12d6-03e4-4f48-9b7b-f95802a6c669',
        name: 'Agreement within Noun Phrases',
        defaultCritiqueValue: 1,
    },
    {
        id: '63e72d3d-62d7-4e73-8d66-c137d8841121',
        name: 'Capitalization',
        defaultCritiqueValue: 1,
    },
    {
        id: 'fd8f4ff7-fa09-492c-9c74-1a6b9f71e488',
        name: 'Comma Missing after Introductory Phrase',
        defaultCritiqueValue: 1,
    },
    {
        id: '72e604b0-a185-413b-bd45-ad555288c746',
        name: 'Comma Splice',
        defaultCritiqueValue: 1,
    },
    {
        id: 'aea1e72a-abf4-4cc8-8b7a-43d15be8fc55',
        name: 'Commonly Confused Words',
        defaultCritiqueValue: 1,
    },
    {
        id: '02c15397-df70-4f00-aa4d-7269e6d4e712',
        name: 'Comparative Use',
        defaultCritiqueValue: 1,
    },
    {
        id: '84275a90-df79-4b9e-a208-9ec8b5e59622',
        name: 'Hyphenation',
        defaultCritiqueValue: 1,
    },
    {
        id: '7c2ff4d7-41a9-4310-949b-863a0dfa4257',
        name: 'Incorrect Verb Form after Auxiliary',
        defaultCritiqueValue: 1,
    },
    {
        id: '6dbfae4c-9818-4dec-a769-2595168927f2',
        name: 'Indefinite Article',
        defaultCritiqueValue: 1,
    },
    {
        id: 'f1a2ad0b-0b26-4bb5-aede-e88c9fe47492',
        name: 'Possessive and Plural Forms',
        defaultCritiqueValue: 1,
    },
    {
        id: '3f2eda01-e8a5-4ed9-9494-6de566bc5333',
        name: 'Punctuation',
        defaultCritiqueValue: 1,
    },
    {
        id: '76e3d0aa-bb80-461e-89c3-9fa640190616',
        name: 'Question Mark Missing',
        defaultCritiqueValue: 1,
    },
    {
        id: '6d1d8c3d-62d5-45d1-b850-d8a98a24964b',
        name: 'Spacing',
        defaultCritiqueValue: 1,
    },
    {
        id: 'd7746119-e7e5-4e97-9979-bcd2114f9fe9',
        name: 'Subject-Verb Agreement',
        defaultCritiqueValue: 1,
    },
    {
        id: '27783a58-c44f-4778-9856-36d9eab63693',
        name: 'Too Many Determiners',
        defaultCritiqueValue: 1,
    },
    {
        id: '352579fc-6ae6-4eb1-8d3b-895ab239714e',
        name: 'Verb Use',
        defaultCritiqueValue: 1,
    },
];

export async function getDefaultOptionsBasedOnFlight() {
    if (isFakeFreeConsumerTestFlightOn()) {
        return mockNonPremiumUserMockOptions;
    } else {
        return lazyGetDefaultOptions.importAndExecute();
    }
}
